// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"882":"eaaa4bc6","941":"62b8ad11"}[chunkId] + ".chunk.js";
};